



















































































































import { Component, Watch, Vue, Prop } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import draggable from "vuedraggable";
import SubmitResetButtonGroop from "../../buttons/submit-reset-button-groop.vue";
import VSelectDropdown from "../../app/dropdowns/route_info/v-select-dropdown.vue";
import LanguagesButtons from "../../buttons/languages-buttons.vue";

import { required, maxLength } from "vuelidate/lib/validators";
import { ILocale } from "@/@types/locale";
import {
  IRouteInfo,
  IRouteCity,
  IFullRoute,
} from "@/@types/routeInfo/route-info";

@Component({
  components: {
    SubmitResetButtonGroop,
    LanguagesButtons,
    VSelectDropdown,
    draggable,
  },
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(60) },
    notes: { maxLength: maxLength(300) },
  },
})
export default class ChangeRouteForm extends Vue {
  @Prop({ type: Object, default: null }) route!: IRouteInfo;

  enabled = true;
  dragging = false;
  router_array: Array<string> = [];

  name = "";
  description = "";
  notes = "";
  citys: Array<IRouteCity> = [];

  active = false;
  names: ILocale = {};
  descriptions: ILocale = {};

  locale = this.$store.getters.getLanguages[0];

  get draggingInfo(): string {
    return this.dragging ? "under drag" : "";
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      console.log("invalid");

      this.$v.$touch();
      return;
    }

    const citys: string[] = [];
    this.citys.forEach((city) => {
      if (city._id) citys.push(city._id);
    });

    const full_route: IFullRoute[] = [];
    for (const city of citys) {
      full_route.push({
        code: city,
        arrival: "",
        departure: "",
        force_arrival: "",
        force_departure: "",
      });
    }

    const route: IRouteInfo = {
      _id: undefined,
      cruise_code: "",
      name: this.names,
      description: this.descriptions,
      start_date: "",
      end_date: "",
      route: citys,
      full_route: full_route,
      duration_in_days: 0,
      notes: this.notes,
      active: this.active,
    };

    this.$emit("onSubmitRoute", route);
  }

  onReset(): void {
    this.name = "";
    this.description = "";
    this.names = {};
    this.descriptions = {};
    this.notes = "";
    this.active = false;
    this.locale = this.$store.getters.getLanguages[0];
  }

  @Watch("name")
  updateName(): void {
    this.names[this.locale] = this.name;
  }

  @Watch("description")
  updateDescription(): void {
    this.descriptions[this.locale] = this.description;
  }

  @Watch("locale")
  getParams(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";

    if (this.descriptions)
      this.description = this.descriptions[this.locale]
        ? this.descriptions[this.locale]
        : "";
    else this.description = "";
  }

  createRoute(): void {
    if (this.route) {
      this.names = this.route.name;
      this.descriptions = this.route.description;
      this.getParams();
      this.notes = this.route.notes;
      this.active = this.route.active;
      this.router_array = this.route.route;
    }
  }

  mounted(): void {
    this.createRoute();
  }
}
